import {SnackBarActions} from '@store/aviary/aviary.adapter';
import {CUSTOM_ERROR_HANDLERS_CREATOR, CustomErrorHandlersCreator} from '@aviary/interceptors/http-error-interceptor.types';
import {HttpContext} from '@angular/common/http';

export function contextWithErrorHandlerForSubmitMakeAPayment(): HttpContext {
  const handler: CustomErrorHandlersCreator = () => ({
    400: {
      discardOriginalErrorResponse: false,
      actionMappers: [
        {
          // requested payment greater than amount owed
          errorCodes: 'GENERAL_INVALID_VALUE',
          actions: SnackBarActions.showError('Payment amount cannot exceed amount owed.')
        }
      ]
    }
  });
  return new HttpContext().set(CUSTOM_ERROR_HANDLERS_CREATOR, handler);
}
